import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import Select from 'react-select';
import useFormValidator from 'useFormValidator';
import * as rptActions from 'modules/real-property-tax/components/actions';
import { GET_ORDINANCE_REVISION } from 'modules/real-property-tax/components/constant';
import * as actions from '../action';
import * as c from '../constant';

function GeneralRevisionModal({
  createGeneralRevision,
  updateGeneralRevision,
  getGeneralRevisionList,
  getSingleGeneralRevision,
  getOrdinanceRevisionList,
  ordinanceRevisionList,
  history,
  type,
  id,
  updateList,
}) {
  const [formData, setFormData] = useState({
    name: '',
    revision_indicator: '',
    ordinance_revision_id: null,
    status: null,
  });

  const validateForm = useFormValidator(formData, {
    name: 'required',
    revision_indicator: 'required',
    ordinance_revision_id: 'required',
    status: 'required',
  });

  const setModal = useContext(ModalContext);

  useEffect(() => {
    getOrdinanceRevisionList();
  }, []);

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSelectChange = (key) => (selected) => {
    setFormData({
      ...formData,
      [key]: selected,
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const args = {
      name: _.get(formData, 'name').replace(/\s+/g, ' ').trim(),
      revision_indicator: _.get(formData, 'revision_indicator'),
      ordinance_revision_id: _.get(formData, 'ordinance_revision_id.value'),
      status: _.get(formData, 'status.value'),
    };

    if (type === 'NEW') {
      createGeneralRevision(args, ({ data }) => {
        setModal({ isOpen: false });
        getGeneralRevisionList();
        history.push(
          `/rpt/settings/general-revisions/${_.get(data, 'id')}`
        );
        getSingleGeneralRevision(data.id);
      });
    }

    if (type === 'EDIT') {
      updateGeneralRevision(id, args, ({ data }) => {
        setModal({ isOpen: false });
        getGeneralRevisionList();
        getSingleGeneralRevision(id);
        history.push(
          `/rpt/settings/general-revisions/${_.get(data, 'id')}`
        );
      });
    }
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  useEffect(() => {
    if (type === 'NEW') {
      setFormData({
        name: '',
        revision_indicator: '',
        ordinance_revision_id: null,
        status: null,
      });
    }
    if (type === 'EDIT' && !_.isEmpty(updateList)) {
      const currentStatus = c.STATUS_OPTIONS.find(
        (opt) => opt.value === _.get(updateList, 'status')
      );
      const currentOrdinance = ordinanceRevisionList.find(
        (opt) => opt.value === _.get(updateList, 'ordinance_revision_id')
      );
      setFormData({
        name: _.get(updateList, 'name') || '',
        revision_indicator: _.get(updateList, 'revision_indicator') || '',
        ordinance_revision_id: currentOrdinance || null,
        status: currentStatus || null,
      });
    }
  }, []);

  const ordinanceOptions = ordinanceRevisionList.map((item) => ({
    value: item.id,
    label: _.get(item, 'attributes.name') || item.id,
  }));

  const selectStyles = {
    control: (base) => ({
      ...base,
      minHeight: 38,
    }),
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="name" className="full-label mb-0">
              Name {validateForm.renderMessage('name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="name"
              onChange={onChange}
              value={_.get(formData, 'name')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="revision_indicator" className="full-label mb-0">
              Revision Indicator{' '}
              {validateForm.renderMessage('revision_indicator')}
            </label>
            <input
              className="form-control"
              type="text"
              name="revision_indicator"
              onChange={onChange}
              value={_.get(formData, 'revision_indicator') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="ordinance_revision_id" className="full-label mb-0">
              Ordinance Revision{' '}
              {validateForm.renderMessage('ordinance_revision_id')}
            </label>
            <Select
              styles={selectStyles}
              placeholder="Select Ordinance Revision"
              options={ordinanceOptions}
              value={_.get(formData, 'ordinance_revision_id')}
              onChange={handleSelectChange('ordinance_revision_id')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="status" className="full-label mb-0">
              Status {validateForm.renderMessage('status')}
            </label>
            <Select
              styles={selectStyles}
              placeholder="Select Status"
              options={c.STATUS_OPTIONS}
              value={_.get(formData, 'status')}
              onChange={handleSelectChange('status')}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={!validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary mr-3"
          >
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark"
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

GeneralRevisionModal.defaultProps = {
  type: '',
  id: '',
  updateList: {},
};

GeneralRevisionModal.propTypes = {
  getGeneralRevisionList: PropTypes.instanceOf(Function).isRequired,
  createGeneralRevision: PropTypes.instanceOf(Function).isRequired,
  updateGeneralRevision: PropTypes.instanceOf(Function).isRequired,
  getSingleGeneralRevision: PropTypes.instanceOf(Function).isRequired,
  getOrdinanceRevisionList: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionList: PropTypes.instanceOf(Array).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  type: PropTypes.string,
  id: PropTypes.string,
  updateList: PropTypes.instanceOf(Object),
};

const mapStateToProps = ({ api }) => ({
  ordinanceRevisionList: _.get(api, `${GET_ORDINANCE_REVISION}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
    getOrdinanceRevisionList: rptActions.getOrdinanceRevisionList,
  }),
]);

export default enhance(GeneralRevisionModal);
